import React, { useState } from 'react';

// const listdataCopy = [
//     { name: 'ワークスペース名', active: false },
//     { name: 'ワークスペース名', active: false },
//     { name: 'ワークスペース名', active: false },
//     { name: 'ワークスペース名', active: false },
//     { name: 'ワークスペース名', active: false },
//     { name: 'ワークスペース名', active: false },
//     { name: 'ワークスペース名', active: false },
//     { name: 'ワークスペース名', active: false },
// ];

const GetTopics = (props) => {
    const [id, setState] = useState(props.id);
    // const [it, setList] = useState({});
    // const [listCopy] = useState(props.data);
    // const [keyCopy, setKeyCopy] = useState(null);
    // const [convertLi, setConvertLi] = useState(true);
    function onCopy(allItem, item) {
        allItem.forEach(i => {
            i.active = false;
            // setKeyCopy(key)
        });
        // if (keyCopy !== key) {

        // } else {
        //     setConvertLi(!convertLi)
        //     convertLi ? item.active = false : item.active = true
        // }
        item.active = true;
    }
    return (
        <div className="wrap-copy-topic" id="wrap-copy-topic">
            <div className="copy-topic" id="copy-topic">
                <h4>他のワークスペースにコピー</h4>
                <div>
                    <ul>
                        {props.data.map((item, key) => {
                            return <li
                                className={item.active ? 'active' : ''}
                                onClick={() => {
                                    onCopy(props.data, item, key);
                                    setState(() => ({ id: item.id }));
                                    // setList(() => ({ it: item }))
                                }}
                                key={key.toString()} > {item.title}</li>
                        })}
                    </ul>
                </div>
                <div>
                    <button onClick={props.hide}>キャンセル</button>
                    <button onClick={() => props.onCopyMulti(id)}>コピーする</button>
                </div>
            </div>
        </div >
    );
}

export default GetTopics;